"use client";
import React from "react";
import dynamic from "next/dynamic";
import { useTranslations } from "next-intl";

function EditorLoading() {
  const t = useTranslations("common");
  return (
    <div className="min-h-[500px] flex justify-center mt-20">
      {t("loading")}
    </div>
  );
}

const SunEditor = dynamic(() => import("suneditor-react"), {
  ssr: false,
  loading: () => <EditorLoading />,
});
import "suneditor/dist/css/suneditor.min.css";

const ViewSunEditor = ({ blog }) => (
  <SunEditor
    hideToolbar={true}
    disableToolbar={true}
    defaultValue={blog}
    disable={true}
    enableToolbar={false}
    showToolbar={false}
    setContents={blog}
    width="100%"
    height="100%"
    setOptions={{
      resizeEnable: false,
      resizingBar: false,
      buttonList: [],
      // SunEditor writes this into its own shadowed content area, which the
      // page's body font never reaches — so the site stack is named explicitly.
      defaultStyle:
        "font-family: var(--font-google-sans), var(--font-ibm-plex-sans-thai), sans-serif;",
    }}
  />
);

export default ViewSunEditor;
